import React, { useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import { PostCompany, UpdateCompany } from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import Button from "@mui/material/Button";
import useLoadingStore from "../../../Redux/Zustand";
import Styles from "../../../UiComponents/Scss/AddPopup.module.scss";
import { NoEncryption } from "@mui/icons-material";

const AddCompany = (props) => {
  const { selectedData, formType, setOpenCompanyDrawer, title, GetActiveData } =
    props;

  const { setLoading } = useLoadingStore();
  let formRef = useRef();

  const initialValues = {
    companyName: "",
    shortName: "",
    remarks: "",
  };

  useEffect(() => {
    if (formType === "edit" || formType === "view") {
      Object.keys(initialValues).forEach((el) => {
        initialValues[el] = selectedData[el];
      });
    }
    formRef.setFieldValue(initialValues);
  }, []);

  const onKeyDownHandler = (e, values) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit(e, values, "Save");
    }
  };

  const onSubmit = (e, data, keys) => {
    let UserId = sessionStorage.getItem("UserId");
    data.updatedAt = new Date();
    ["companyName", "remarks", "shortName"].forEach(
      (item) => (data[item] = data[item]?.toUpperCase())
    );

    if (e.key === "Enter" || keys === "Save") {
      if (formType === "add") {
        data.createdBy = UserId;
      } else if (formType === "edit") {
        data.updatedBy = UserId;
      }

      let SubmitType =
        formType === "edit"
          ? UpdateCompany(selectedData._id, data)
          : PostCompany(data);
      SubmitType.then((res) => {
        if (!res) {
          setOpenCompanyDrawer(true);
        } else {
          GetActiveData();
          setOpenCompanyDrawer(false);
        }
      }).catch((error) => {
        console.log(error);
      });
    } else if (keys === "Save&Create") {
      PostCompany(data).then((res) => {
        GetActiveData();
        if (res) {
          formRef.resetForm();
        }
      });
    }
  };

  return (
    <>
      <div className="DrawerContainer">
      <Grid container className="DrawerHeader">
        <Grid item xs={6} sm={6}>
          <Typography>{title} Company </Typography>
        </Grid>
        <Grid item xs={6} sm={6} className="d-flex justify-content-end">
          <CloseIcon
            onClick={() => setOpenCompanyDrawer(false)}
            sx={{ cursor: "pointer" }}
          />
        </Grid>
      </Grid>
      <Formik
        initialValues={initialValues}
        innerRef={(ref) => {
          if (ref) {
            formRef = ref;
          }
        }}
      >
        {({ values }) => (
          <Form onKeyDown={(e) => onKeyDownHandler(e, values)}>
            <div className={Styles.addContent}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  {/* <FloatLabel label="Company Name" value={values.companyName}> */}
                  <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Company Name
                    </Typography>
                    <Field
                      disabled={formType === "view" ? true : false}
                      name="companyName"
                      placeHolder="Enter Company Name"
                      className="InputFiled"
                      style={{ textTransform: "uppercase", }}
                    />
                  {/* </FloatLabel> */}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {/* <FloatLabel label="Short Name" value={values.shortName}> */}
                  <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      ShortName
                    </Typography>
                    <Field
                      disabled={formType === "view" ? true : false}
                      name="shortName"
                       placeHolder="Enter Short Name"
                      className="InputFiled"
                      style={{ textTransform: "uppercase", }}
                    />
                  {/* </FloatLabel> */}
                </Grid>
                <Grid item xs={12} sm={12}>
                <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1,}}
                    >
                      Remarks
                    </Typography>
                  {/* <FloatLabel label="Remarks" value={values.remarks}> */}
                  <div className="common-field-wrapper">
                    <Field
                      name="remarks"
                      className="InputFileds"
                      disabled={formType === "view" ? true : false}
                      placeholder={formType !== "view" && formType !== "edit" ? "Write here..." : ""}
                      // style={{ height: "90px", minHeight: "90px" }}
                      style={{ textTransform: "uppercase",  }}
                    />
                     </div>
                  {/* </FloatLabel> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: formType === "view" ? "block" : "none" }}
                >
                   <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Created Date
                    </Typography>
                  {/* <FloatLabel label="Created Date" value={"react"}> */}
                    <Field
                      name="createdAt"
                      className="InputFiled"
                      disabled={formType === "view" ? true : false}
                      value={moment(selectedData?.createdAt).format("L")}
                    />
                  {/* </FloatLabel> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: formType === "view" ? "block" : "none" }}
                >
                  <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Updated Date
                    </Typography>
                  {/* <FloatLabel label="Updated Date" value={"react"}> */}
                    <Field
                      name="updatedAt"
                      className="InputFiled"
                      disabled={formType === "view" ? true : false}
                      style={{ textTransform: "uppercase" }}
                      value={moment(selectedData?.updatedAt).format("L")}
                    />
                  {/* </FloatLabel> */}
                </Grid>
              </Grid>
            </div>
            <div className="Dialog_Footers">
            <div className="Dialog_Button_Groups"> 
              <Button
                onClick={() => setOpenCompanyDrawer(false)}
                className="Dialog_Cancels"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                onClick={(e) => onSubmit(e, values, "Save")}
                className="Dialog_Saves"
                sx={{ display: formType === "view" ? "none" : "block" 
                 }}
              >
                {selectedData?._id ? "Update" : "Save & Exit"}
              </Button>
              </div>
              <Button
                sx={{ display: formType === "add" ? "block" : "none",
                  marginLeft: "10px", 
                 }}
                onClick={(e) => onSubmit(e, values, "Save&Create")}
                className="Dialog_Save_Exits"
              >
                Save & Create new
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
    </>
  );
};

export default AddCompany;
